import { Text, ArrowUpRightIcon } from '@donaswap/uikit'
import styled from 'styled-components'
import { useTheme } from '@donaswap/hooks'
import { AutoRow } from 'components/Layout/Row'
import { useActiveChainId } from 'hooks/useActiveChainId'
import { NATIVE } from '@donaswap/sdk'
import Link from 'next/link'
import { NetworkAlertChains, SHOULD_SHOW_ALERT } from './ShouldShowAlert'
import { TEXT_COLORS } from './TextColors'
import { BG_COLORS_BY_DARK_MODE_AND_CHAIN_ID } from './BackgroundColors'
import { ChainLogo } from '../Logo/ChainLogo'

export const Controls = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  padding: 0 20px 20px 20px;
`

const BodyText = styled.div`
  color: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 8px;
  font-size: 14px;
`

const RootWrapper = styled.div`
  position: relative;
  margin-top: 16px;
`

const ContentWrapper = styled.div<{ chainId: NetworkAlertChains; isDark: boolean }>`
  background: ${({ chainId, isDark }) => BG_COLORS_BY_DARK_MODE_AND_CHAIN_ID[isDark ? 'dark' : 'light'][chainId]};
  border: 1px solid ${({ theme }) => theme.colors.primarytab2};
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  position: relative;
  width: 100%;

  :before {
    background-repeat: no-repeat;
    background-size: 300px;
    content: '';
    height: 300px;
    opacity: 0.1;
    position: absolute;
    transform: rotate(25deg) translate(-90px, -40px);
    width: 300px;
    z-index: -1;
  }
`

const Header = styled.h2`
  font-weight: 600;
  font-size: 16px;
  margin: 0;
`

const LinkOutToBridge = styled.div`
  align-items: center;
  border-radius: 8px;
  color: white;
  display: flex;
  font-size: 16px;
  justify-content: space-between;
  padding: 6px 8px;
  margin-right: 12px;
  text-decoration: none !important;
  width: 100%;
`

const StyledArrowUpRightIcon = styled(ArrowUpRightIcon)`
  margin-left: 12px;
  width: 24px;
  height: 24px;
`

function shouldShowAlert(chainId: number | undefined): chainId is NetworkAlertChains {
  return Boolean(chainId && SHOULD_SHOW_ALERT[chainId as unknown as NetworkAlertChains])
}

export function NetworkAlert() {
  const { chainId } = useActiveChainId()
  const { isDark } = useTheme()

  if (!shouldShowAlert(chainId)) {
    return null
  }

  const { bridge, label } = NATIVE[chainId]
  const textColor = TEXT_COLORS[chainId]

  return bridge ? (
    <RootWrapper>
      <ContentWrapper chainId={chainId} isDark={isDark}>
        <Link href={bridge} target="_blank">
          <LinkOutToBridge>
            <BodyText>
              {/* <NetworkIcons mr="8px" avatarSrc={`/images/chains/${chainId}.png`} /> */}
              <ChainLogo chainId={chainId} />
              <AutoRow>
                <Header>
                  <Text fontSize="14px" color={textColor}>
                    {label} token bridge
                  </Text>
                </Header>
                <Text fontSize="8px" color={textColor}>
                  Deposit tokens to the {label} network.
                </Text>
              </AutoRow>
            </BodyText>
            <StyledArrowUpRightIcon color={textColor} />
          </LinkOutToBridge>
        </Link>
      </ContentWrapper>
    </RootWrapper>
  ) : null
}
